import { openWebAppLink, SubscriptionServiceOfferEnum } from '@landr/core';
import { useCallback } from 'react';
import { CONFIG } from 'utils';

export const useUnlockPlanRedirect = () => {
    const unlockWithPlanRedirect = useCallback(() => {
        const destination = `/pricing?origin=${
            SubscriptionServiceOfferEnum.Samples
        }&returnUrl=${encodeURIComponent('/samples')}`;

        openWebAppLink(CONFIG.VITE_APP_ENV, destination);
    }, []);

    return unlockWithPlanRedirect;
};
